<template>
    <div class="guide" v-if="steps.length > 0">
        <p v-if="headline" class="guide__headline">{{ headline }}</p>
        <ul class="guide__list">
            <li class="guide__list-item" v-for="step in steps">
                <img v-if="step.HasSvgUrl" :src="step.SvgUrl" width="70" height="70" :alt="step.ImageAltText" />
                <div class="guide__list-item-text">
                    <p class="guide__list-item-title">{{ step.Headline }}</p>
                    <p v-if="dictionary" v-html="step.Text.replace('{appDownload}', '').replace('{bookLink}','')"></p>
                    <div v-if="dictionary && step.Text.includes('{appDownload}')" class="app-download-buttons">
                        <a class="app-download-buttons__button app-download-buttons__button--ios" target="_blank"
                            :href="dictionary.AppLinkAppStore">
                            <img src="/assets/images/appstore.png" alt="Apple App Store icon" loading="lazy" />
                        </a>

                        <a class="app-download-buttons__button app-download-buttons__button--play" target="_blank"
                            :href="dictionary.AppLinkPlayStore">
                            <img src="/assets/images/playstore.png" alt="Google Play Store icon" loading="lazy" />
                        </a>
                    </div>
                    <div v-if="step.Text.includes('{bookLink}')">
                        <button type="button" @click="handleGuideButtonBookLinkClick">Book nu</button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "guide",
    props:["headline","dictionary","steps"],
    methods:{
        handleGuideButtonBookLinkClick(){
            this.$emit('bookLinkClick');
        }
    }
};
</script>
